import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';
import { normalizarRutaMedia, resolverUrlMedia } from '../utils/media-url.util';

export interface VideoPantalla {
  idvideo?: number;
  nombre?: string;
  url: string;
  esVideo: number;
  idSucursal?: number;
  orden?: number;
  activo: number;
  idYouTube?: string;
}

@Injectable()
export class BannerService {
  private apiBase = environment.url + '/api';

  constructor(private http: Http) { }

  normalizarRuta(url: string): string {
    return normalizarRutaMedia(url);
  }

  resolverUrl(url: string): string {
    return resolverUrlMedia(url);
  }

  listar(): Observable<VideoPantalla[]> {
    return this.http.get(this.apiBase + '/Videos?filter[order]=orden%20ASC')
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  crear(video: VideoPantalla): Observable<VideoPantalla> {
    const payload = { ...video, url: normalizarRutaMedia(video.url) };
    return this.http.post(this.apiBase + '/Videos', payload)
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  actualizar(id: number, video: Partial<VideoPantalla>): Observable<VideoPantalla> {
    const payload = { ...video };
    if (payload.url) {
      payload.url = normalizarRutaMedia(payload.url);
    }
    return this.http.patch(this.apiBase + '/Videos/' + id, payload)
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  eliminar(id: number): Observable<any> {
    return this.http.delete(this.apiBase + '/Videos/' + id)
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  subirArchivo(archivo: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', archivo);

    return this.http.post(this.apiBase + '/containers/banners/upload', formData)
      .map((res: Response) => {
        const body = res.json();
        let fileInfo = null;

        if (body.result && body.result.files && body.result.files.file) {
          fileInfo = body.result.files.file[0] || body.result.files.file;
        } else if (body.files && body.files.file) {
          fileInfo = body.files.file[0] || body.files.file;
        }

        if (!fileInfo || !fileInfo.name) {
          throw new Error('No se pudo obtener el archivo subido');
        }
        return '/storage/banners/' + fileInfo.name;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Observable<any> {
    return Observable.throw(error.message || error);
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/services/banner.service.ts